import React from 'react'

import CircularProgress, {
  CircularProgressProps
} from '@mui/material/CircularProgress'

export type SpinnerProps = CircularProgressProps

const Spinner = (props: SpinnerProps) => {
  return <CircularProgress {...props} />
}

export default Spinner
